import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";
import SEO from "../components/SEO";
import { Check, Loader2, Home } from "lucide-react";

export default function BookingSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const isFree = params.get("free") === "1" || (sessionId || "").startsWith("free_");
  const [status, setStatus] = useState({ loading: true, paid: false });

  useEffect(() => {
    if (!sessionId) {
      setStatus({ loading: false, paid: false });
      return;
    }
    // Free booking — no Stripe session to poll, jump straight to success.
    if (isFree) {
      setStatus({ loading: false, paid: true, free: true });
      return;
    }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus({ loading: false, paid: true, data });
          return;
        }
      } catch (e) { /* ignore polling errors, will retry */ }
      tries += 1;
      if (tries < 10) setTimeout(poll, 2000);
      else setStatus({ loading: false, paid: false });
    };
    poll();
  }, [sessionId, isFree]);

  return (
    <div className="min-h-screen bg-apex-bg flex items-center justify-center p-6">
      <SEO title="Potvrzení rezervace" description="Potvrzení platby a rezervace detailingu vozu u Apex Detailing." path="/booking-success" noindex />
      <div className="max-w-md w-full rounded-3xl bg-apex-surface border border-apex-line p-8 text-center">
        {status.loading ? (
          <>
            <Loader2 className="w-12 h-12 animate-spin text-apex-gold mx-auto" />
            <h2 className="mt-4 font-display text-2xl text-apex-cream">Ověřujeme platbu...</h2>
            <p className="mt-2 text-apex-cream/70 text-sm">Chvilku strpení, prosím.</p>
          </>
        ) : status.paid ? (
          <>
            <div className="w-16 h-16 mx-auto rounded-full bg-emerald-500/15 text-emerald-300 flex items-center justify-center">
              <Check className="w-8 h-8" />
            </div>
            <h2 className="mt-4 font-display text-2xl text-apex-cream font-bold">
              {status.free ? "Rezervace zdarma!" : "Platba úspěšná!"}
            </h2>
            <p className="mt-2 text-apex-cream/70">
              {status.free
                ? "Slevový kód pokryl celou cenu. Detaily najdete ve svém účtu i v e-mailu."
                : "Děkujeme. Detaily najdete ve svém účtu i v e-mailu."}
            </p>
          </>
        ) : (
          <>
            <h2 className="font-display text-2xl text-apex-cream font-bold">Platba se nezdařila</h2>
            <p className="mt-2 text-apex-cream/70">Pokud platba proběhla, kontaktujte nás prosím.</p>
          </>
        )}
        <Link to="/" className="btn-gold mt-6 inline-flex"><Home className="w-4 h-4" /> Zpět na web</Link>
      </div>
    </div>
  );
}
